import { put, takeLatest } from 'redux-saga/effects';
import i18n from '../../utils/i18n';
import { displayToast, type ToastMessageProps } from './toastSlice';
import { watchList } from './watchList';

type ToastAction = {
 payload?: unknown;
 type?: string;
};

const toastTypes: ToastMessageProps['type'][] = [
 'info',
 'success',
 'warning',
 'error',
];

const isRecord = (value: unknown): value is Record<string, unknown> =>
 typeof value === 'object' && value !== null && !Array.isArray(value);

const getFallbackMessage = (actionType?: string) => {
 const translationKey = actionType?.endsWith('Failure')
  ? 'global.operationFailed'
  : 'global.operationSucceeded';

 return i18n.t(translationKey);
};

function* toastSaga(data: ToastAction) {
 try {
  const payload = isRecord(data?.payload) ? data.payload : undefined;
  const payloadType = payload?.type;
  const type = toastTypes.includes(
   payloadType as ToastMessageProps['type'],
  )
   ? (payloadType as ToastMessageProps['type'])
   : data?.type?.endsWith('Failure')
    ? 'error'
    : data?.type?.endsWith('Success')
     ? 'success'
     : 'info';
  const payloadMessage = payload?.message ?? payload?.title;
  const message =
   typeof payloadMessage === 'string' && payloadMessage.trim()
    ? payloadMessage
    : getFallbackMessage(data?.type);

  yield put(displayToast({ type, message }));
 } catch {
  // A malformed watched action must never terminate the toast or root saga.
  console.error('Unable to create toast notification from watched action');
 }
}

export function* watchToastSaga() {
 yield takeLatest(
  watchList.map((action) => action.type),
  toastSaga,
 );
}
